<template lang="pug">
TheDetail(
	:groups="groups"
	title="Завод"
	title-new="Создать завод"
	@remove="removeFactory"
	@save="saveFactory"
	:deleteButtonDisabled="isAdmin"
)
ModalWorkers(v-model:show="modal" endpoint="factory" :filter="{filterValue: ['FACTORY', 'WEB_RECEPTION', 'FACTORY_NRS'], filterKey: 'authorities', path: 'name'}" @create="createWorker")
TheModalAlert(
	v-model:show="alertDelete.show",
	title="После удаления работника с объекта этот объект теряет право участвовать в приемке и сдаче, так как участник отсутствует. Удалить?",
	cancelText="Нет",
	confirmText="Да",
	@confirm="confirmDelete(alertDelete.idWorker)"
)
</template>

<script>
import { computed, onMounted, reactive, ref } from 'vue'

import { useApi } from '../modules/api'
import { useDetail } from '../modules/composition/useDetail'
import { useBasic } from '../modules/composition/inputs/useBasic'
import { useWorkers } from '../modules/composition/useWorkers'
import { useFishes } from '../modules/composition/useFishes'

import TheDetail from '../components/TheDetail'
import ModalWorkers from '../components/modals/ModalWorkers'
import TheModalAlert from '../components/TheModalAlert.vue'

export default {
	name: 'PortDetail',
	components: { TheModalAlert, TheDetail, ModalWorkers },
	setup () {
		const { idDetail, isNew, notFoundDetail, saveDetail, removeDetail } = useDetail()
		const isAdmin = JSON.parse(localStorage.account).roles?.ADMIN

		const alertDelete = reactive({
			show: false,
			idWorker: null
		})

		const confirmDelete = async (id) => {
			await deleteWorker(id)
			alertDelete.show = false
		}

		const saveFactory = async () => {
			const body = bodyBasic()

			await saveDetail({
				endpoint: '/factory/create',
				body,
				workers,
				createWorkerApi
			})
		}

		const removeFactory = async () => {
			await removeDetail(`/factory/${idDetail}`)
		}

		const createWorkerApi = async ({ id, workerId, postId }) => {
			const { post, data } = useApi('/factory/createWorker')

			await post({
				factory: { id: id || idDetail },
				worker: { id: workerId },
				workerPost: { id: postId }
			})

			return data.value?.id
		}

		const updateWorkerApi = () => {
			return new Promise((resolve, reject) => {
				(async () => {
					try {
						const { get, data, error } = useApi(`/factory/${idDetail}`)

						await get()

						if (error.value) {
							throw new Error('Не удалось обновить список работников')
						}

						const workerList = data.value.listOfWorkers.reduce((acc, worker) => {
							const { id, workerFIO: title, postName: status } = worker
							acc[id] = { id, title, status }
							return acc
						}, {})
						resolve(workerList)
					} catch (error) {
						reject(error)
					}
				})()
			})
		}

		const { workers, setWorker, createWorker, deleteWorker } = useWorkers({
			updateWorkerApi,
			createWorkerApi,
			deleteEndpoint: '/factory/deleteWorker',
			idDetail,
			isNew
		})

		const { basic, setBasic, bodyBasic } = useBasic()
		const { fishes, setFishes } = useFishes()

		const getAction = async () => {
			const { get, data } = useApi(`/factory/${idDetail}/actions`)
			await get()

			return data.value || []
		}

		const groups = reactive({
			main: {
				title: 'Общие данные',
				grid: 2,
				inputs: basic
			},
			events: {
				title: 'События',
				hide: true,
				hideNew: true,
				count: computed(() => groups.events.collapses.length),
				collapses: fishes
			},
			workers: {
				title: 'Работники',
				grid: 2,
				count: computed(() => Object.keys(groups.workers.cards).length),
				icon: 'plus',
				onClick: () => {
					modal.value = true
				},
				iconCard: 'user',
				button: 'Удалить',
				buttonClick: (id) => {
					if (Object.keys(workers).length === 1) {
						alertDelete.idWorker = id
						alertDelete.show = true
					} else {
						deleteWorker(id)
					}
				},
				cards: workers
			}
		})

		onMounted(async () => {
			if (!isNew) {
				const { get, data, error } = useApi(`/factory/${idDetail}`)

				await get()

				if (error.value) return notFoundDetail()

				const {
					name,
					phone,
					address,
					listOfWorkers
				} = data.value

				const listOfActions = await getAction()

				setBasic({ name, phone, address })

				setFishes(listOfActions)

				listOfWorkers.forEach(work => {
					const { id, workerFIO: title, postName: status } = work
					setWorker({ id, title, status })
				})
			} else {
				setBasic({ name: '', phone: '', address: '' })
			}
		})

		const modal = ref(false)

		return {
			groups,
			alertDelete,
			modal,
			isAdmin,

			createWorker,
			confirmDelete,

			removeFactory,
			saveFactory
		}
	}
}
</script>
